import {
  AutomationStatusType,
  BroadcastStateType,
} from "@/types/graphql/partner.generated";

/** Подписи состояний рассылки (чип в списке и в шапке диалога). */
export const BROADCAST_STATE_KEYS: Record<BroadcastStateType, string> = {
  [BroadcastStateType.DraftType]: "broadcasts.state.DRAFT",
  [BroadcastStateType.ScheduledType]: "broadcasts.state.SCHEDULED",
  [BroadcastStateType.SendingType]: "broadcasts.state.SENDING",
  [BroadcastStateType.SentType]: "broadcasts.state.SENT",
  [BroadcastStateType.ArchivedType]: "broadcasts.state.ARCHIVED",
};

/** Статусы в фильтре списка (PAUSED у рассылок не бывает). */
export type BroadcastFilterStatus =
  | AutomationStatusType.DraftType
  | AutomationStatusType.ActiveType
  | AutomationStatusType.ArchivedType;

export const BROADCAST_FILTER_STATUSES: BroadcastFilterStatus[] = [
  AutomationStatusType.DraftType,
  AutomationStatusType.ActiveType,
  AutomationStatusType.ArchivedType,
];

export const BROADCAST_STATUS_KEYS: Record<BroadcastFilterStatus, string> = {
  [AutomationStatusType.DraftType]: "broadcasts.status.DRAFT",
  [AutomationStatusType.ActiveType]: "broadcasts.status.ACTIVE",
  [AutomationStatusType.ArchivedType]: "broadcasts.status.ARCHIVED",
};

export type BroadcastTemplateId =
  | "blank"
  | "announcement"
  | "buyersNews"
  | "winBack";

export interface BroadcastTemplateOption {
  id: BroadcastTemplateId;
  /** Ключ шаблона на бэкенде (domains/marketing/templates); null у пустой. */
  templateKey: string | null;
  titleKey: string;
  descriptionKey: string;
}

/** Варианты в диалоге создания рассылки. */
export const BROADCAST_TEMPLATES: BroadcastTemplateOption[] = [
  {
    id: "blank",
    templateKey: null,
    titleKey: "broadcasts.templates.blank.title",
    descriptionKey: "broadcasts.templates.blank.description",
  },
  {
    id: "announcement",
    templateKey: "announcement",
    titleKey: "broadcasts.templates.announcement.title",
    descriptionKey: "broadcasts.templates.announcement.description",
  },
  {
    id: "buyersNews",
    templateKey: "buyersNews",
    titleKey: "broadcasts.templates.buyersNews.title",
    descriptionKey: "broadcasts.templates.buyersNews.description",
  },
  {
    id: "winBack",
    templateKey: "winBack",
    titleKey: "broadcasts.templates.winBack.title",
    descriptionKey: "broadcasts.templates.winBack.description",
  },
];
